import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const WithdrawalDtoSchema = z
    .object({
        payoutIds: z
            .array(z.string())
            .optional()
            .describe(
                'List of specific payout IDs to withdraw. If omitted, all ready payouts in the specified currency will be withdrawn.',
            ),
    })
    .strict();

export class WithdrawalDto extends FromSchema(WithdrawalDtoSchema) {
    payoutIds?: string[];
}
